var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playbar-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-708.000000, -1450.000000)",
    id: "assets"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.000000, 1378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pbIconVolume",
    transform: "translate(640.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7187153,21.0008392 C16.7187153,21.8251853 15.8029264,22.2920948 15.1753755,21.7972674 L11.5909777,18.9131555 L9.83810541,18.9131555 C9.39350298,18.9131555 9.00102202,18.5289003 9.00102202,18.0340729 L9,13.9670244 C9,13.5001148 9.36589692,13.0879418 9.83708339,13.0879418 L11.5899557,13.0879418 L15.1743535,10.2027307 C15.8019043,9.70790327 16.7176933,10.1748238 16.7176933,10.9991589 L16.7187153,21.0008392 Z M19.2565495,18.6104556 C18.9683115,18.8573307 18.523709,18.8025887 18.2886391,18.5009715 L18.2365124,18.4462294 C18.001432,18.1714474 18.0535587,17.7313565 18.3407658,17.5124102 C18.7853682,17.1828916 19.0470222,16.6333276 19.0470222,16.0011092 C19.0470222,15.4236273 18.7853682,14.9019811 18.3928873,14.5445447 C18.0791118,14.2697627 18.0269904,13.8296718 18.2886339,13.5001533 C18.5237143,13.1974534 18.9693529,13.1427168 19.2831283,13.3906691 C20.0159687,13.9949697 20.4605712,14.929888 20.4605712,16.0010982 C20.4605712,17.0712367 19.9893847,18.006155 19.2565443,18.6104556 Z M20.8796152,20.6713207 C20.5913772,20.9181958 20.1467748,20.8634537 19.9117049,20.5618365 C19.6766245,20.2591367 19.7021776,19.7922271 19.9904052,19.5453629 C20.9848996,18.7210169 21.6124505,17.4297613 21.6124505,16.0012246 C21.6124505,14.572578 20.9848996,13.3081411 19.9904052,12.4570863 C19.7021671,12.2102111 19.6500457,11.7422134 19.9117049,11.4406127 C20.1467853,11.1379128 20.5924238,11.0831762 20.8796152,11.3311285 C22.1878851,12.4302565 22.9994311,14.1336302 22.9994311,16.0024226 C23.0249832,17.8958355 22.1878851,19.5723905 20.8796152,20.6715185 L20.8796152,20.6713207 Z",
    id: "volume",
    fill: "#858199"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/iconVolume.b9d413d1.svg";
export { ForwardRef as ReactComponent };